import { render } from "./Interview.vue?vue&type=template&id=0a675ca0&scoped=true"
import script from "./Interview.vue?vue&type=script&lang=js"
export * from "./Interview.vue?vue&type=script&lang=js"

import "./Interview.vue?vue&type=style&index=0&id=0a675ca0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a675ca0"]])

export default __exports__